/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WorkActivities {
    angular.module("meevo.plugins.workActivities", []);
}